/**
 * @generated SignedSource<<7710f5d817b428da8f6b69241f5a4773>>
 * @relayHash f17910d7238a6b3b3bb14c58a49066f8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f17910d7238a6b3b3bb14c58a49066f8

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocGender = "FEMALE" | "MALE" | "OTHER";
export type de_BetterDocRecommendationDelivery = "MSN" | "PMN";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type de_BetterDocSecondOpinion = "NOT_APPLICABLE" | "NOT_REQUIRED" | "REQUIRED";
export type de_BetterDocSelectionType = "ACTIVITY" | "MEDIC";
export type betterDocRemoteRecommendationQuery$variables = {
  recommendationId: string;
};
export type betterDocRemoteRecommendationQuery$data = {
  readonly de_betterDocRemoteRecommendation: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly httpStatusCode: number | null;
    readonly recommendation: {
      readonly caseId: string | null;
      readonly failureOrRejectionReason: string | null;
      readonly insertedAt: string;
      readonly insuranceCountry: Country;
      readonly localSessionId: number | null;
      readonly medics: ReadonlyArray<{
        readonly gender: de_BetterDocGender | null;
        readonly glnNumber: string | null;
        readonly medhubId: number;
        readonly name: string;
        readonly selectionId: number;
        readonly selectionType: de_BetterDocSelectionType;
        readonly travelTimeCar: number | null;
        readonly workplace: {
          readonly address: string | null;
          readonly ancestorName: string | null;
          readonly city: string | null;
          readonly countryCode: string | null;
          readonly name: string;
          readonly postalCode: string | null;
        } | null;
        readonly zsrNumber: string | null;
      }>;
      readonly partnerPatientId: string;
      readonly partnerSessionId: string;
      readonly recommendationDelivery: de_BetterDocRecommendationDelivery | null;
      readonly recommendationId: string;
      readonly secondOpinion: de_BetterDocSecondOpinion | null;
      readonly secondOpinionVisitConfirmedByPatientAt: string | null;
      readonly selectionId: number | null;
      readonly selectionType: de_BetterDocSelectionType | null;
      readonly state: de_BetterDocRecommendationState;
      readonly updatedAt: string;
    } | null;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocRemoteRecommendationQuery = {
  response: betterDocRemoteRecommendationQuery$data;
  variables: betterDocRemoteRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recommendationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "recommendationId",
        "variableName": "recommendationId"
      }
    ],
    "concreteType": "de_BetterDocRemoteRecommendationResult",
    "kind": "LinkedField",
    "name": "de_betterDocRemoteRecommendation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocRemoteRecommendation",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "failureOrRejectionReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationDelivery",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCountry",
            "storageKey": null
          },
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondOpinion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondOpinionVisitConfirmedByPatientAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "medics",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medhubId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "glnNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zsrNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "travelTimeCar",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_BetterDocRemoteWorkplace",
                "kind": "LinkedField",
                "name": "workplace",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ancestorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postalCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocRemoteRecommendationQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocRemoteRecommendationQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "f17910d7238a6b3b3bb14c58a49066f8",
    "metadata": {},
    "name": "betterDocRemoteRecommendationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2f0bf55e7951bbb82834a7aa40e09f57";

export default node;
